module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/icon-align-to-bottom.b2cec5ee73d6b1b5b1f66adbe217d6dc.svg";